<template>
  <div class="home">
   <Register/>
  </div>
</template>

<script>
import Register from '../components/Register.vue'
export default {
  components:{
    Register
  },
  name: 'HomeView',

}
</script>
<style>
h1{
  color: black;
}
</style>
